import { actionTypes } from '../actions/alertlj'

const initial = {
	message: '',
	type: '',
	visible: false
}

export default (state = initial, action) => {

	// Get token from local Storage
   switch (action.type) {
  	case actionTypes.ALERT_ERROR:
      return Object.assign({}, state, {
        message: action.data.message,
				type: 'danger',
				visible: true
    	})

		case actionTypes.ALERT_SUCCESS:
      return Object.assign({}, state, {
        message: action.data.message,
				type: 'success',
				visible: true
    	})

		case actionTypes.CLEAR_ALERT:
			return Object.assign({}, state, {
				message: '',
				type: '',
				visible: false
			})
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/alertlj.js